// سطر الرقم المرجعي داخل التقرير المطبوع — بارز وبخط عريض كعنوان التقرير.
import { esc } from "../payroll/reportFormat";

export const refLine = (share, label = "الرقم المرجعي") =>
  share?.reference
    ? `<div class="refline" data-testid="report-reference">${esc(label)} <span class="refno">${esc(share.reference)}</span></div>`
    : "";
